import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acc9eec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info__top" }
const _hoisted_3 = { class: "info__details" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex"} }, "About C4E Tokens", -1 /* HOISTED */))
const _hoisted_6 = { class: "links" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode($setup["PublicSaleInfo"])
        ]),
        _createElementVNode("div", null, [
          _createVNode($setup["InvestmentCalculator"], {
            onOnBuy: $setup.onBuyClick,
            disabled: "!activeRound"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.TOKENOMICS')), 1 /* TEXT */),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.WHITE_PAPER')), 1 /* TEXT */)
          ])
        ]),
        _createCommentVNode("      <h3>{{$t('BUY_TOKENS_VIEW.DESCRIPTION_FIRST_HEADER')}}</h3>"),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.DESCRIPTION_FIRST_CONTENT')), 1 /* TEXT */),
        _createCommentVNode("      <h3>{{$t('BUY_TOKENS_VIEW.DESCRIPTION_SECOND_HEADER')}}</h3>"),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.DESCRIPTION_SECOND_CONTENT')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactions, (items) => {
          return (_openBlock(), _createElementBlock("div", {
            key: items,
            class: "userProfile__holder"
          }, [
            _createVNode($setup["AllocationInfo"], {
              transaction: items,
              onPay: ($event: any) => ($setup.onPay(items)),
              onCancelAllocation: ($event: any) => ($setup.onCancelAllocation(items.orderId))
            }, null, 8 /* PROPS */, ["transaction", "onPay", "onCancelAllocation"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createVNode($setup["BuyTokensModal"], {
      visible: $setup.showModal,
      onCloseModal: _cache[0] || (_cache[0] = ($event: any) => ($setup.showModal = false)),
      onConfirm: $setup.onPayReservation,
      reservation: $setup.selectedReservation
    }, null, 8 /* PROPS */, ["visible", "reservation"]),
    _createVNode($setup["OrderModal"], {
      onOnConnect: _cache[1] || (_cache[1] = ($event: any) => ($setup.loginPopupStatus=true)),
      onOnAcceptTerms: $setup.showApprovalModalFunc,
      onOnKycStart: $setup.onKycStart,
      onOnProvideClaimerAddress: $setup.provideClaimerAddress,
      onOnProvideSourceAddress: $setup.provideSourceAddress
    }),
    ($setup.showApprovalModal)
      ? (_openBlock(), _createBlock($setup["ApprovalModal"], {
          key: 0,
          onClose: $setup.hideApprovalModal,
          onSubmit: $setup.hideApprovalModal
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["ProvideAddresInfoModal"], {
      "address-type": $setup.showAddressInfoModalAddressType,
      address: $setup.showAddressInfoModalAddressType == $setup.AddressType.METAMASK ? $setup.useUserStore().metamaskConnectionInfo.address : $setup.c4eAddress,
      display: $setup.showAddressInfoModal,
      onConfirm: $setup.addressConfirmed,
      onClose: $setup.closeProvideAddressModalClose
    }, null, 8 /* PROPS */, ["address-type", "address", "display"]),
    _createVNode($setup["Dialog"], {
      visible: $setup.kycModalVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.kycModalVisible) = $event)),
      onHide: _cache[5] || (_cache[5] = ($event: any) => ($setup.useUserServiceStore().getKycStatus())),
      modal: "",
      header: "KYC",
      style: { width: '95vw', 'max-width': '600px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode($setup["SynapsVerify"], {
            sessionId: $setup.sessionId,
            color: { primary: '72bf44', secondary: 'ffffff' },
            lang: "en",
            tier: $setup.useTransactionContextStore().getRequiredKycTierId,
            service: "individual",
            onReady: _cache[2] || (_cache[2] = ($event: any) => (console.log('ready'))),
            onFinish: _cache[3] || (_cache[3] = ($event: any) => ($setup.kycModalVisible = false))
          }, null, 8 /* PROPS */, ["sessionId", "tier"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    ($setup.loginPopupStatus)
      ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
          key: 1,
          showAddressOption: false,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus)),
          onConnected: _cache[7] || (_cache[7] = ($event: any) => ($setup.onShowInfoModal($setup.AddressType.KEPLR)))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["ConfirmDialogYesNo"], {
      onAccepted: $setup.cancelAllocation,
      ref: "confirmDialogYesNoRef"
    }, null, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}